import { render, staticRenderFns } from "./SubmissionsTable.vue?vue&type=template&id=88c15be8&scoped=true&"
import script from "./SubmissionsTable.vue?vue&type=script&lang=js&"
export * from "./SubmissionsTable.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionsTable.vue?vue&type=style&index=0&id=88c15be8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c15be8",
  null
  
)

export default component.exports